import { eocIncidentsEntryPoint } from '@jira/spa-apps__eoc-changes-and-incidents/src/eocIncidents.entrypoint.tsx';
import { eocIncidentsRoute } from '@jira/router-routes__eoc-incidents-routes/src/eocIncidentsRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { eocServicedeskCustomFieldsResource } from '@jira/router-resources__eoc-changes-and-incidents/src/eocServicedeskCustomFieldsResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import type { Route } from '@atlassian/react-resource-router';

const eocIncidentsPageEntrypoint = createPageEntryPoint({
	main: eocIncidentsEntryPoint,
});

export const eocIncidentsRouteEntry: Route = createEntry(eocIncidentsRoute, () => ({
	group: 'eoc',

	navigation: {
		menuId: 'PROJECTS',
	},

	resources: [...getNavigationResources(), eocServicedeskCustomFieldsResource],

	entryPoint: () =>
		expValEquals('changes-and-incidents-under-operations', 'isEnabled', true, false)
			? eocIncidentsPageEntrypoint
			: notFoundPageEntrypoint,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
